import { HandshakePhoto, useReport } from '@motorway/motorway-handshake-components';

import { BackButton } from '../../components/BackButton/BackButton';
import { Hr } from '../../components/Hr/Hr';

import styles from './DamageReport.module.scss';

export const DamageReport = () => {
  const { report } = useReport();

  const { images = [], inspection } = report ?? {};
  const { description } = inspection ?? {};

  return (
    <>
      <BackButton padding />
      <div className={styles.component}>
        <h2>Additional damage found</h2>
        <p>The inspection found damage that wasn't in your original listing.</p>
        <Hr />
        <h6>Comments:</h6>
        <p>{description ?? 'No comments'}</p>
      </div>
      <div>
        {
          images.map(({ url }, index) => (
            <HandshakePhoto key={index} url={url} />
          ))
        }
      </div>
    </>
  );
};
